<template>
  <CoreModal
    :modelValue="isOpen"
    :title="$t('Login')"
    :closeOnOverlay="allowClose"
    :showCloseButton="true"
    @update:modelValue="handleVisibility"
  >
    <LoginForm ref="loginForm" @login-success="onLoginSuccess" @go-to-register="goToRegister" />
  </CoreModal>
</template>

<script setup lang="ts">
import { ref, computed, watch } from "vue";
import { useRouter, useRoute } from "vue-router";
import { useUIStore } from "@/stores/useUIStore";
import CoreModal from "@/components/modal/CoreModal.vue";
import LoginForm from "@/components/auth/LoginForm.vue";

const uiStore = useUIStore();
const router = useRouter();
const route = useRoute();

const isOpen = computed(() => uiStore.loginIsOpen);
const allowClose = computed(() => uiStore.allowClosePopup);

const loginForm = ref<InstanceType<typeof LoginForm> | null>(null);

const emit = defineEmits<{
  (event: "login-success"): void;
}>();

const handleClose = () => {
  loginForm.value?.reset();
  uiStore.closeLogin();
};

const handleVisibility = (value: boolean) => {
  if (!value) handleClose();
};

watch(isOpen, (value) => {
  if (!value) loginForm.value?.reset();
});

const onLoginSuccess = () => {
  const fallbackRedirect =
    typeof route.query.redirect === "string" ? route.query.redirect : null;
  const redirectTarget = uiStore.loginRedirect || fallbackRedirect || "";

  uiStore.setLoginRedirect(null);
  handleClose();

  const shouldNavigate =
    Boolean(redirectTarget) && redirectTarget !== route.fullPath;
  if (shouldNavigate) {
    router.push(redirectTarget).catch(() => null);
  }

  emit("login-success");
};

const goToRegister = () => {
  const redirectTarget = uiStore.loginRedirect || route.fullPath || "";
  uiStore.setLoginRedirect(redirectTarget);
  handleClose();
  router
    .push({ name: "Register", query: { redirect: redirectTarget } })
    .catch(() => null);
};
</script>
